import { createContext, ReactNode } from 'react'

/**
 * @deprecated Use CustomModalHeader from ArcadeModalActionContext
 */
export type ModalActionsElement = ReactNode

type ModalActionContextValue = { actions: ModalActionsElement; setModalActions: (actions: ModalActionsElement) => void }

const error = () => {
  throw Error('ModalActionProvider not found')
}

/**
 * @deprecated Use ArcadeModalActionContext
 */
export const ModalActionContext = createContext<ModalActionContextValue>({
  actions: undefined,
  setModalActions: error,
})
